<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { checkbox } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';
  import formatarData from '~js/formatar-data';
  import atividadeServico from '~modulos/atividade/servico';
  import tipoCertidaoServico from '~modulos/certidao/servico';
  import tiposConta from '~js/tipos-conta';
  import tiposPessoaConta from '~js/tipos-pessoa-conta';
  import bancoServico from '~modulos/banco/servico';

  export default {
    components: { checkbox },
    props: {
      fornecedor: {
        type: Object,
        required: true,
      },
      arquivos: {
        type: Array,
        required: true,
      },
      arquivosNaoSalvos: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        responsavelAlteracao: {
          cpf: '',
          nome: '',
          email: '',
          aceite: false,
        },
        tipoAtividades: [],
        tiposConta: tiposConta,
        tiposPessoaConta: tiposPessoaConta,
        tiposCerdidoes: [],
        bancos: [],
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar(valido) {

        if (!valido) throw new Error("validacao com erro");


        return this.$validator.validateAll();
      },
      nomeTipoAtividade(id) {
        return this.tipoAtividades.find(atividade => {
          return atividade.idAtividade === id;
        }).nomeAtividade;
      },
      carregarTipoAtividades() {
        return atividadeServico.
          lista()
          .then(tipoAtividades => {
            this.tipoAtividades = tipoAtividades
              .filter((atividade) => atividade.fgPortal == '1' || atividade.fgPortal == 1)
              .sort((atividade1, atividade2) => {
                if (atividade1.nomeAtividade > atividade2.nomeAtividade) {
                  return 1;
                }
                if (atividade1.nomeAtividade < atividade2.nomeAtividade) {
                  return -1;
                }
                return 0;
              });
          });
      },
      nomeTipoConta(tipo) {
        tipo = tipo !== -1 ? tipo : -1;
        if (tipo == -1) {
          return "---";
        } else {
          return this.tiposConta.find(tipoConta => {
            return tipoConta.id === tipo;
          }).nome;
        }
      },
      nomeTipoPessoaConta(tipoPessoa) {
        tipoPessoa = tipoPessoa ? tipoPessoa : 0;
        if (tipoPessoa == 0) {
          return "---";
        } else {
          return this.tiposPessoaConta.find(tipoPessoaConta => {
            return tipoPessoaConta.id === tipoPessoa;
          }).nome;
        }
      },
      nomeBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).nome;
      },
      numeroBanco(id) {
        return this.bancos.find(banco => {
          return banco.idBanco === id;
        }).numero;
      },
      carregarBancos() {
        return bancoServico.
          lista()
          .then(bancos => {
            this.bancos = bancos;
            this.bancosAtivos = bancos.filter(banco => banco.disponibilizarWEB);
          });
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      carregarTiposCerdidoes() {
        return tipoCertidaoServico.
          lista()
          .then(tiposCertidoes => {
            this.tiposCerdidoes = tiposCertidoes;
          });
      },
      nomeTipoCertidao(id) {
        return this.tiposCerdidoes.find(tipoCertidao => {
          return tipoCertidao.idCertidao === id;
        }).nomeCertidao;
      },
      formatarDataCertidao(intData) {
        return formatarData.paraData(intData)
      },
      gerarObjetoDeDados() {
        const obj = {
          dadosGerais: {
            cnpj: this.fornecedor.cpfCnpj || '---',
            razaoSocial: this.fornecedor.nomePessoaFisicaJuridica || '---',
            nomeFantasia: this.fornecedor.nomeFantasia || '---',
            endereco: this.enderecoFornecedor,
            inscricaoEstadual: this.fornecedor.identidadeInscEstadual || '---',
            inscricaoMunicipal: this.fornecedor.carteiraTrabalhoInscMunicipal || '---',
            ramoAtividade: this.atividadesFornecedor,
          },
          socios: [],
          contatos: {
            telefoneComercial: this.fornecedor.telefone2 || '---',
            contatoFinanceiro: {
              nome: this.fornecedor.contato || '---',
              email: this.fornecedor.email || '---',
              telefone: this.fornecedor.telContatoFinanceiro || '---'
            }
          },
          referenciaBancaria: this.fornecedor.dadosBancarios.map((dadoBancario) => ({
            banco: `${this.nomeBanco(dadoBancario.idBanco)} - ${dadoBancario.numeroBanco}`,
            agencia: dadoBancario.numeroAgencia,
            numeroConta: dadoBancario.numeroConta,
            tipoConta: this.nomeTipoConta(dadoBancario.tipoConta),
            tipoPessoa: this.nomeTipoPessoaConta(dadoBancario.tipoPessoa)
          })),
          certidoes: this.fornecedor.certidoes.map((certidao) => ({
            nome: certidao.nomeArquivo,
            tipoCertidao: this.nomeTipoCertidao(certidao.idCertidao),
            numeroCertidao: certidao.numeroCertidao,
            dataValidadeInicial: this.formatarDataCertidao(certidao.dataValidade),
            dataValidadeFinal: this.formatarDataCertidao(certidao.dataValidadeFim)
          })),
          outrosArquivos: [...this.arquivos, ...this.arquivosNaoSalvos],
          aceiteTermoResponsabilidade: 
             `Eu, ${this.responsavelAlteracao.nome || '<< SEM NOME >>'}, portador do documento CPF nº ${this.responsavelAlteracao.cpf || '<< SEM CPF >>'} e contato de e-mail ${this.responsavelAlteracao.email || '<< SEM EMAIL >>'}, estou ciente e atesto as informações aqui apresentadas.`      
        };

        this.fornecedor.socios.forEach((socio) => {
          obj.socios.push({
            nome: socio.nome,
            cpf: socio.cpf,
            dataEntrada: formatarData.paraData(socio.dataEntrada),
            dataSaida: socio.dataSaida ? formatarData.paraData(socio.dataSaida) : '---',
            percentualCotas: socio.percentualCotas
          });
        });

        const newObj = {
          cpfPessoaAceite: this.responsavelAlteracao.cpf,
          nomePessoaAceite: this.responsavelAlteracao.nome,
          emailPessoaAceite: this.responsavelAlteracao.email,
          resumoAceite: JSON.stringify(obj)
        };

        return newObj;
      }
    },
    mounted() {
      this.carregarTipoAtividades();
      this.carregarBancos();
      this.carregarTiposCerdidoes();
    },
    computed: {
      enderecoFornecedor() {
        let endereco = '';
        if (this.fornecedor.endereco) {
          endereco = endereco + this.fornecedor.endereco;
        }
        if (this.fornecedor.numero) {
          endereco = endereco + ', ' + this.fornecedor.numero;
        }
        if (this.fornecedor.complemento) {
          endereco = endereco + ', ' + this.fornecedor.complemento;
        }
        if (this.fornecedor.bairro) {
          endereco = endereco + ', ' + this.fornecedor.bairro;
        }
        if (this.fornecedor.cidade) {
          endereco = endereco + ', ' + this.fornecedor.cidade;
        }
        if (this.fornecedor.estado) {
          endereco = endereco + '/' + this.fornecedor.estado;
        }

        endereco = endereco + '. ';

        if (this.fornecedor.cep) {
          endereco = endereco + 'CEP ' + this.fornecedor.cep;
        }
        return endereco;
      },
      atividadesFornecedor() {
        let atividades = 'Não informado';
        if (this.fornecedor.atividades && this.fornecedor.atividades.length > 0) {
          const arrayAtividades = this.fornecedor.atividades
            .map((atividade) => this.nomeTipoAtividade(atividade.idAtividade))

          atividades = arrayAtividades.join(', ');
        }
        return atividades;
      },
    },
  }

</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('aceiteCpf')}">
          <label class="control-label" for="endereco">CPF do responsável</label>

          <input id="aceiteCpf"
                 class="form-control"
                 type="text"
                 v-model="responsavelAlteracao.cpf"
                 v-mascara="'cpf'"
                 data-vv-name="aceiteCpf"
                 data-vv-as="CPF"
                 v-validate="'required|cpf'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('aceiteCpf')">{{ errors.first('aceiteCpf') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('aceiteNome')}">
          <label class="control-label" for="numero">Nome do responsável</label>

          <input id="aceiteNome"
                 class="form-control"
                 type="text"
                 v-model="responsavelAlteracao.nome"
                 data-vv-name="aceiteNome"
                 data-vv-as="nome"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('aceiteNome')">{{ errors.first('aceiteNome') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('aceiteEmail')}">
          <label class="control-label" for="aceiteEmail">E-mail do responsável</label>

          <input id="aceiteEmail"
                 class="form-control"
                 type="text"
                 v-model="responsavelAlteracao.email"
                 data-vv-name="aceiteEmail"
                 data-vv-as="e-mail"
                 v-validate="'required|email'"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('aceiteEmail')">{{ errors.first('aceiteEmail') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <h1><b>Resumo dos dados informados</b></h1>
            <p>Verifique abaixo todos os dados informados neste cadastro.</p>
            <br />

            <h2><b>Dados gerais</b></h2>

            <div class="row">
              <dl class="col-xs-12">
                <dt>CNPJ</dt>
                <dd>{{ fornecedor.cpfCnpj || '---'}}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-6">
                <dt>Razão social</dt>
                <dd>{{ fornecedor.nomePessoaFisicaJuridica || '---' }}</dd>
              </dl>
              <dl class="col-xs-6">
                <dt>Nome fantasia</dt>
                <dd>{{ fornecedor.nomeFantasia || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Endereço</dt>
                <dd>{{ enderecoFornecedor }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-6">
                <dt>Inscrição estadual</dt>
                <dd>{{ fornecedor.identidadeInscEstadual || '---' }}</dd>
              </dl>
              <dl class="col-xs-6">
                <dt>Inscrição municipal</dt>
                <dd>{{ fornecedor.carteiraTrabalhoInscMunicipal || '---' }}</dd>
              </dl>
            </div>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Ramo(s) de atividade</dt>
                <dd>{{ atividadesFornecedor }}</dd>
              </dl>
            </div>

            <h2><b>Sócios</b></h2>
            <div class="table-responsive">
              <table class="table table-hover table-pointer">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Data de entrada</th>
                    <th>Data de saida</th>
                    <th>% Cotas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(socio, indice) in fornecedor.socios">
                    <td>{{ socio.nome }}</td>
                    <td>{{ socio.cpf }}</td>
                    <td>{{ socio.dataEntrada | formatarNumeroEmData }}</td>
                    <td>{{ socio.dataSaida | formatarNumeroEmData('---') }}</td>
                    <td>{{ socio.percentualCotas }}</td>
                  </tr>
                  <tr v-if="fornecedor.socios.length === 0">
                    <td colspan="6" class="text-center">Nenhum sócio informado.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2><b>Contatos</b></h2>

            <div class="row">
              <dl class="col-xs-12">
                <dt>Telefone comercial</dt>
                <dd>{{ fornecedor.telefone2 || '---' }}</dd>
              </dl>
            </div>

            <h3><b>Contato financeiro</b></h3>

            <div class="row">
              <dl class="col-xs-4">
                <dt>Nome do contato</dt>
                <dd>{{ fornecedor.contato || '---' }}</dd>
              </dl>
              <dl class="col-xs-4">
                <dt>E-mail do contato</dt>
                <dd>{{ fornecedor.email || '---' }}</dd>
              </dl>
              <dl class="col-xs-4">
                <dt>Telefone do contato</dt>
                <dd>{{ fornecedor.telContatoFinanceiro || '---' }}</dd>
              </dl>
            </div>

            <h2><b>Referência bancária</b></h2>

            <div class="table-responsive">
              <table class="table table-hover table-pointer">
                <thead>
                  <tr>
                    <th>Banco</th>
                    <th>Agência</th>
                    <th>Número da conta</th>
                    <th>Tipo de conta</th>
                    <th>Tipo de pessoa</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(dadoBancario, indice) in fornecedor.dadosBancarios">
                    <td>{{ nomeBanco(dadoBancario.idBanco) }} - {{ dadoBancario.numeroBanco }}</td>
                    <td>{{ dadoBancario.numeroAgencia }}</td>
                    <td>{{ dadoBancario.numeroConta }}</td>
                    <td>{{ nomeTipoConta(dadoBancario.tipoConta) }}</td>
                    <td>{{ nomeTipoPessoaConta(dadoBancario.tipoPessoa) }}</td>
                  </tr>
                  <tr v-if="fornecedor.dadosBancarios.length === 0">
                    <td colspan="5" class="text-center">Nenhuma referência bancária informada.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <h1><b>Termo de responsabilidade</b></h1>

            <p>
              À {{ configuracao.nomeFundacao }} - {{ configuracao.abreviaturaFundacao }} <br />
              {{ configuracao.enderecoFundacao }} - {{ configuracao.bairroFundacao }} <br />
              {{ configuracao.cepFundacao }} - {{ configuracao.cidadeFundacao }}/{{ configuracao.estadoFundacao }} <br />
              A/C: Setor de Licitação e Contratos
            </p>

            <p>
              A empresa <b>{{ fornecedor.nomePessoaFisicaJuridica }}</b>,
              inscrita no CNPJ sob o nº <b>{{ fornecedor.cpfCnpj }}</b>,
              com sede na <b>{{ enderecoFornecedor }}</b>,
              solicita a inscrição no Cadastro de Pessoa Jurídica da {{ configuracao.abreviaturaFundacao }}.
            </p>

            <p>
              Para tal, apresentamos o presente formulário de solicitação de Cadastro de Pessoa Jurídica,
              devidamente preenchido e verificado, juntamente com os documentos abaixo listados:
            </p>

            <h2><b>Arquivos</b></h2>

            <div class="hr-line-dashed margin-top-5"></div>

            <h3><b>Certidões</b></h3>
            <!-- LISTA DE CERTIDÕES -->

            <div class="table-responsive">
              <table class="table table-hover table-pointer">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Tipo de certidão</th>
                    <th>Número da Certidão</th>
                    <th>Data de validade inicial</th>
                    <th>Data de validade final</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(certidao, indice) in fornecedor.certidoes">
                    <td>
                      {{ certidao.nomeArquivo }}
                    </td>
                    <td>
                      {{nomeTipoCertidao(certidao.idCertidao) }}
                    </td>
                    <td>
                      {{ certidao.numeroCertidao }}
                    </td>
                    <td>
                      {{formatarDataCertidao(certidao.dataValidade) }}
                    </td>
                    <td>
                      {{formatarDataCertidao(certidao.dataValidadeFim) }}
                    </td>
                  </tr>
                  <tr v-if="fornecedor.certidoes.length === 0">
                    <td colspan="6" class="text-center">Nenhuma certidão informada.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3><b>Outros arquivos</b></h3>
            <!-- LISTA DE ARQUIVOS -->

            <div class="table-responsive">
              <table class="table table-hover table-pointer">
                <thead>
                  <tr>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(arquivo, indice) in arquivos">
                    <td>{{ nomeArquivo(arquivo) }}</td>

                  </tr>

                  <tr v-for="(arquivo, indice) in arquivosNaoSalvos">
                    <td>{{ arquivo }}</td>

                  </tr>
                  <tr v-if="arquivos.length === 0 && arquivosNaoSalvos.length === 0">
                    <td colspan="6" class="text-center">Nenhum arquivo informado.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>


            <!-- INFORMAÇÕES DE UMA VARIÁVEL -->

            <div class="row" v-if="configuracao.textoDeclaracaoResumoAceiteFornecedor">
              <div class="col-sm-12">
                <div v-html="configuracao.textoDeclaracaoResumoAceiteFornecedor" />
                <br />
              </div>
            </div>

            <!-- FINAL -->

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group required" :class="{'has-error': errors.has('aceiteCheckbox')}">
                  <div class="checkbox">
                    <label>
                      <input id="aceiteCheckbox"
                             class="custom-checkbox remove-margin form-control "
                             type="checkbox"
                             v-model="responsavelAlteracao.aceite"
                             data-vv-name="aceiteCheckbox"
                             v-validate="'required'">
                      Eu, <b>{{ responsavelAlteracao.nome || '<< SEM NOME >>' }}</b>,
                      portador do documento CPF nº <b>{{ responsavelAlteracao.cpf || '<< SEM CPF >>' }}</b>
                      e contato de e-mail <b>{{ responsavelAlteracao.email || '<< SEM EMAIL >>' }}</b>,
                      estou ciente e atesto as informações aqui apresentadas.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
    .panel-resposta {
      background: transparent !important;
      padding-left: 10px;
      padding-right: 10px;
      border-width: 1px;
      border-color: lightgray;
      border-radius: 3px;
      border-style: solid;
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 15px;
    }

    .form-group-resposta {
      margin-bottom: 0px;
    }

  .custom-checkbox {
    width: 14px;
    height: 14px;
  }

  .custom-checkbox.remove-margin {
    margin-top: 2px;
  }

</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormResumoAceite.vue